"use client";

import st from "./index.module.scss";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { useStore } from "@/hooks/use-store";
import CashbackBonusModal from "@/components/Modal/Bonuses/Cashback";

export default function CashbackBonus() {
  const t = useTranslations("CashbackBonus");
  const { modal } = useStore();

  return (
    <>
      <div onClick={() => modal.showModal(<CashbackBonusModal />)}>
        <div className={st.header}>
          <div className={st.header_image}>
            <Image
              src="/images/bonuses/cashback.webp"
              alt="Bazz Bet Cashback"
              width={351}
              height={234}
              loading="lazy"
              sizes="(max-width: 768px) 100vw, 800px"
              style={{ width: "100%", height: "auto" }}
            />
          </div>
          <div className={st.header_title}>
            <span className={st.header_title__orange}>+15%</span> {t("title")}
          </div>
        </div>

        <div className={st.description}>{t("description")}</div>

        <div className={st.button}>
          <button className={`${st.button__btn}`}>{t("more")}</button>
        </div>
      </div>
    </>
  );
}
